import { appNameConstants, LabsterClient } from '@zg-rentals/particles-js-labster';
import requester from 'app/shared/utils/requester';
import appLogger from 'app/shared/loggers/appLogger';

const labster = new LabsterClient({
    appName: appNameConstants.ZRM,
    proxyPath: 'rental-manager/labster-proxy',
    requester,
    logger: appLogger, // Server logger
    log: appLogger, // Client logger
});

export default labster;
